import { render, staticRenderFns } from "./academic_course_management.vue?vue&type=template&id=cc6d74a6&scoped=true"
import script from "./academic_course_management.vue?vue&type=script&lang=js"
export * from "./academic_course_management.vue?vue&type=script&lang=js"
import style0 from "./academic_course_management.vue?vue&type=style&index=0&id=cc6d74a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6d74a6",
  null
  
)

export default component.exports